import { render, staticRenderFns } from "./GeoTargeting.vue?vue&type=template&id=2b9667f7&"
import script from "./GeoTargeting.vue?vue&type=script&lang=js&"
export * from "./GeoTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports